import { render, staticRenderFns } from "./ImportPayrollModal.vue?vue&type=template&id=00940d3c&scoped=true&"
import script from "./ImportPayrollModal.vue?vue&type=script&lang=ts&"
export * from "./ImportPayrollModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00940d3c",
  null
  
)

export default component.exports